<template>
  <div>
    <div style="background-color: rgb(243.9, 244.2, 244.8);">
    <div class="first-picture-font">
      <div class="gothamBold">
        COMPANY NEWS
      </div>
      <div class="puHuiTi-Medium" style="font-size: 1.5rem;font-weight: lighter">
        新闻中心
      </div>

      <el-image
          style="height: 2.5rem;padding-top: 0.8rem;  animation: smooth-bounce 2s infinite; /* 匀速跳动动画 */"
          :src="down" fit="cover"/>
    </div>
      <el-image
          style="width: 100%;height: 23rem"
          :src="titlePicture"
          fit="cover"
      />
      <!--    标题图片-->
          <newsTemplate :pictures="pictures" :importEquip="importEquip" :total="pictures.length">
          </newsTemplate>

    </div>
  </div>
</template>

<script setup>
let titlePicture = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/news_1.jpg"
let news_2 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/news_2.jpg"
import newsTemplate from '@/components/newsTemplate.vue'
import down from "@/assets/img/down.png"
import {onMounted, ref} from "vue";
import {getNewsData,getImagePath} from "@/utils/utils";

// const activeName = ref('companyNews')
const pictures = ref([
])
const importEquip = ref({
  "img_url": news_2,
  "date": "5月1日",
  "title": "行业巨头强强联合，推动齿轮行业技术新突破",
  "desc": "此次合作旨在结合双方的优势资源与技术实力，共同攻克齿轮行业长期存在的技术难题",
})


const loadJsonData = () => {
  try {
    // 循环 jsonData 的每个键（key），并将它们追加到 menuItems
    let newsData = getNewsData()
    console.log(newsData)
    newsData[0].img_url = getImagePath(newsData[0].img_url,"news")

    importEquip.value = newsData[0]
    for (let i = 1; i < newsData.length; i++) {
      newsData[i].img_url = getImagePath(newsData[i].img_url,"news")
      pictures.value.push(newsData[i]);
    }
  } catch (error) {
    console.error("读取 JSON 文件失败:", error);
  }
};



onMounted(() => {
  loadJsonData();
});

</script>

<style scoped>
.factory-tab > /deep/ .el-tabs__header {
  background-color: white !important;
  height: 3rem;
}


/deep/div.el-tabs.el-tabs--top.news-tab > div.el-tabs__header.is-top > div > div > div > div.el-tabs__active-bar.is-top{
  background-color: #003795; /* 红色激活条 */
}

/deep/#tab-allNews{
  margin-left: 6rem;
}
</style>